import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=44cc6d2d&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=44cc6d2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cc6d2d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44cc6d2d')) {
      api.createRecord('44cc6d2d', component.options)
    } else {
      api.reload('44cc6d2d', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=44cc6d2d&scoped=true&", function () {
      api.rerender('44cc6d2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24KTSa65vd27v/JS/comp/GuestBox.vue"
export default component.exports